module.exports = __webpack_public_path__ + "img/1F61F.b4261011.svg";